import { Button } from 'react-bootstrap';
import { RiSendPlaneFill } from 'react-icons/ri';
import { VscLoading } from 'react-icons/vsc';
import { FormattedMessage } from 'react-intl';

function SubmitBtn({ isLoading, onClick, buttonText, icon }) {
  return (
    <Button
      className="btn-sm ms-2"
      variant="success"
      type="submit"
      disabled={isLoading}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}>
      {isLoading ? (
        <VscLoading className="spin" />
      ) : (
        <>
          {icon ? '' : <RiSendPlaneFill color="white" className="me-2" />}
          {buttonText ? buttonText : <FormattedMessage id="button.submit" />}
        </>
      )}
    </Button>
  );
}

export default SubmitBtn;
